document.addEventListener('DOMContentLoaded', function () {
  var btn = document.querySelector('.menu-btn');
  var nav = document.querySelector('.nav');
  if (btn && nav) {
    btn.addEventListener('click', function () {
      nav.classList.toggle('open');
      btn.textContent = nav.classList.contains('open') ? '✕' : '☰';
      btn.setAttribute('aria-expanded', nav.classList.contains('open') ? 'true' : 'false');
    });
    nav.querySelectorAll('a').forEach(function(a) {
      a.addEventListener('click', function() {
        nav.classList.remove('open');
        btn.textContent = '☰';
        btn.setAttribute('aria-expanded', 'false');
      });
    });
  }

  var frames = document.querySelectorAll('.hero-frame');
  if (frames.length && !(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches)) {
    var i = 0;
    setInterval(function () {
      frames[i].classList.remove('active');
      i = (i + 1) % frames.length;
      frames[i].classList.add('active');
    }, 5000);
  }

  var ticker = document.querySelector('.hero-ticker');
  if (ticker) {
    var track = document.createElement('div');
    track.className = 'ticker-track';
    track.innerHTML = ticker.innerHTML + ticker.innerHTML;
    ticker.innerHTML = '';
    ticker.appendChild(track);
  }
});
function initNuShoresBanners(root) {
  var host = root || document;
  var shells = host.matches && host.matches('[data-banner-slider]') ? [host] : host.querySelectorAll('[data-banner-slider]');
  Array.prototype.forEach.call(shells, function(shell) {
    if (shell.dataset.initialized === 'true') return;
    shell.dataset.initialized = 'true';
    var viewport = shell.querySelector('.banner-slider-viewport');
    var slides = Array.prototype.slice.call(shell.querySelectorAll('.banner-slide'));
    if (!viewport || slides.length < 2) return;
    var current = 0;
    var intervalSeconds = parseInt(shell.dataset.autoplay, 10) || 0;
    var reducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var paused = intervalSeconds === 0 || reducedMotion;
    var timer;
    var toggle = shell.querySelector('[data-pause-slides]');
    function updateToggle() {
      if (!toggle) return;
      toggle.textContent = paused ? '▶' : 'Ⅱ';
      toggle.setAttribute('aria-label', paused ? 'Play slideshow' : 'Pause slideshow');
      toggle.setAttribute('aria-pressed', paused ? 'true' : 'false');
    }
    function show(index) {
      current = (index + slides.length) % slides.length;
      viewport.scrollTo({left: slides[current].offsetLeft - slides[0].offsetLeft, behavior: 'smooth'});
      var label = shell.querySelector('[data-current]');
      if (label) label.textContent = String(current + 1);
    }
    function stop() { if (timer) clearInterval(timer); timer = null; }
    function start() {
      stop();
      if (!paused && intervalSeconds > 0) timer = setInterval(function() { show(current + 1); }, intervalSeconds * 1000);
    }
    shell.querySelector('.banner-prev').addEventListener('click', function() { show(current - 1); start(); });
    shell.querySelector('.banner-next').addEventListener('click', function() { show(current + 1); start(); });
    if (toggle) toggle.addEventListener('click', function() {
      paused = !paused;
      updateToggle();
      start();
    });
    viewport.addEventListener('scroll', function() {
      current = Math.max(0, Math.min(slides.length - 1, Math.round(viewport.scrollLeft / viewport.clientWidth)));
      var label = shell.querySelector('[data-current]');
      if (label) label.textContent = String(current + 1);
    }, {passive: true});
    updateToggle();
    start();
  });
}
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', function() { initNuShoresBanners(document); });
} else {
  initNuShoresBanners(document);
}
document.addEventListener('shopify:section:load', function(event) { initNuShoresBanners(event.target); });
